import React from "react";
import ReactDOM from "react-dom";
import VariableDataModel from "../models/VariableDataModel";
import Utility from "../utilities/Utility";

export default class InputSuggestion extends React.Component {
    /**
     * Suggestion box for input box; shows a list of suggestion items
     * @module InputSuggestion
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.navKeyHandler = this.handleNavKey.bind(this);
        this.selection = null;
    }

    /**
     * Get reference to suggestion box itself
     * @returns {jQuery}
     */
    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    /**
     * Handle clicks of navigation keys; navigate the item list
     * @param {Object} event Document CustomEvent
     */
    handleNavKey(event) {
        const domSelfItems = this.getDomSelf().children("li");
        domSelfItems.find("button").removeClass("hovered");
        if (event.detail === "up") {
            if (this.selection === null) {
                this.selection = domSelfItems.length - 1;
            } else {
                this.selection--;
            }
            if (this.selection < 0) {
                this.selection = domSelfItems.length - 1;
            }
        } else if (event.detail === "down") {
            if (this.selection === null) {
                this.selection = 0;
            } else {
                this.selection++;
            }
            if (this.selection > domSelfItems.length - 1) {
                this.selection = 0;
            }
        } else if (event.detail === "enter") {
            if (this.selection >= 0) {
                this.props.context.applySuggestion(domSelfItems.eq(this.selection).find("div").data("name"), this.props.type);
                this.unregister();
                this.selection = null;
            }
        }
        if (this.selection !== null && this.selection >= 0) {
            domSelfItems.eq(this.selection).find("button").addClass("hovered");
            const container = this.getDomSelf().parent();
            const hovered = $(".hovered");
            if (hovered.position().top >= container.height()) {
                container.scrollTop(hovered.position().top - container.height() + container.scrollTop());
            } else if (hovered.position().top <= container.position().top) {
                container.scrollTop(container.scrollTop() - container.position().top + hovered.position().top);
            }
        }
    }

    componentDidMount() {
        document.addEventListener('ev-input-nav-key', this.navKeyHandler);
    }

    componentDidUpdate() {
        document.addEventListener('ev-input-nav-key', this.navKeyHandler);
        this.selection = null;
    }

    componentWillUnmount() {
        this.unregister();
    }

    unregister() {
        document.removeEventListener('ev-input-nav-key', this.navKeyHandler);
    }

    renderVariableSuggestions() {
        var display = [];
        for (var key in this.props.suggestions) {
            if (!this.props.suggestions.hasOwnProperty(key)) {
                continue;
            }
            const uid = Utility.uuid4();
            let nameLine;
            let name;
            let hint;
            let useKey = (this.props.context.props.keyType && this.props.context.props.keyType === "conversationVariable") ? 
                "conv" : key;
            for (var i = 0; i < this.props.suggestions[key].length; i++) {
                const node = this.props.suggestions[key][i];
                if (node.type === "variable") {
                    name = node.getConfig("varName");
                    nameLine = name;
                    hint = node.getConfig("alias") ? node.getConfig("alias") : VariableDataModel.getTypeName(node.getConfig("type"));
                }
                else {
                    name = this.props.suggestions[key][i].varName;
                    nameLine = this.props.suggestions[key][i].varName;
                }


                var firstOccur = -1, query = "";
                const lowName = nameLine.toLowerCase();
                // Highlight based on query, either scope.variableName or variableName
                if (this.props.snippet[2]) {
                    query = this.props.snippet[2].substring(1);
                    const lowQuery = query.toLowerCase();
                    firstOccur = lowName.indexOf(lowQuery);
                } else {
                    query = this.props.snippet[1];
                    const lowQuery = query.toLowerCase();
                    firstOccur = lowName.indexOf(lowQuery);
                }
                if (firstOccur >= 0) {
                    nameLine = <span>
                        {nameLine.substring(0, firstOccur)}
                        <span className="search-highlight">{nameLine.substring(firstOccur, firstOccur + query.length)}</span>
                        {nameLine.substring(firstOccur + query.length)}
                    </span>;
                }
                display.push(

                    <li key={useKey + uid + i}>
                        <div
                            style={{ width: "auto", marginLeft: "-12px", marginRight: "-12px" }}
                            data-name={useKey + "." + name}
                            onMouseDown={event => {
                                this.props.context.applySuggestion(event.currentTarget.dataset.name, this.props.type);
                                document.removeEventListener('ev-input-nav-key', this.navKeyHandler);
                                this.selection = null;
                            }}
                        >
                            <button
                                className="form-list-item item-button"
                            >
                                <div>{nameLine}</div>
                                <div
                                    className="subtext">{useKey}</div>
                            </button>
                        </div>
                    </li>
                );
            }
        }
        return display;
    }

    renderIntentSuggestions() {
        var display = [];
        for (var key in this.props.suggestions) {
            if (!this.props.suggestions.hasOwnProperty(key)) {
                continue;
            }
            const uid = Utility.uuid4();
            for (var i = 0; i < this.props.suggestions[key].length; i++) {
                const node = this.props.suggestions[key][i];
                let inUse = null;

                // if (this.props.excludeInUse && this.props.inUse.length > 0) {
                //     inUse = this.props.inUse.find(intent => intent.intent === node.value);
                // }

                display.push(
                    <li key={key + uid + i}>
                        <div
                            style={{ width: "auto", marginLeft: "-12px", marginRight: "-12px" }}
                            data-name={node.value}
                            onClick={event => {
                                //dont allow selection if global intent is already in use
                                if (event.target.classList.contains('inUse')) {
                                    event.preventDefault();
                                    return false;
                                }
                                this.props.context.applySuggestion(event.currentTarget.dataset.name, this.props.type);
                                document.removeEventListener('ev-input-nav-key', this.navKeyHandler);
                                this.selection = null;
                            }}
                        >
                            <button
                                className="form-list-item item-button"
                            >
                                <div className={(inUse) ? "inUse" : ""}>{node.name}</div>
                            </button>
                        </div>
                    </li>
                );
            }
        }
        return display;
    }

    renderPromptSuggestions() {
        var display = [];
        for (var key in this.props.suggestions) {
            if (!this.props.suggestions.hasOwnProperty(key)) {
                continue;
            }
            const uid = Utility.uuid4();
            for (var i = 0; i < this.props.suggestions[key].length; i++) {
                const node = this.props.suggestions[key][i];

                display.push(
                    <li key={key + uid + i}>
                        <div
                            style={{width: "auto", marginLeft: "-12px", marginRight: "-12px"}}
                            data-name={node.name}
                            onClick={event => {
                                this.props.context.applySuggestion(event.currentTarget.dataset.name, this.props.type);
                                document.removeEventListener('ev-input-nav-key', this.navKeyHandler);
                                this.selection = null;
                            }}
                        >
                            <button
                                className="form-list-item item-button"
                            >
                                <div>{node.name}</div>
                            </button>
                        </div>
                    </li>
                );
            }
        }
        return display;
    }

    renderModuleSuggestions() {
        var display = [];
        for (var key in this.props.suggestions) {
            if (!this.props.suggestions.hasOwnProperty(key)) {
                continue;
            }
            const uid = Utility.uuid4();
            for (var i = 0; i < this.props.suggestions[key].length; i++) {
                const node = this.props.suggestions[key][i];
                let inUse = null;
                display.push(
                    <li key={key + uid + i}>
                        <div
                            style={{ width: "auto", marginLeft: "-12px", marginRight: "-12px" }}
                            data-name={node}
                            onClick={event => {

                                this.props.context.applySuggestion(event.currentTarget.dataset.name, this.props.type);
                                document.removeEventListener('ev-input-nav-key', this.navKeyHandler);
                                this.selection = null;
                            }}
                        >
                            <button className="form-list-item item-button">
                                <div className={(inUse) ? "inUse" : ""}>{node}</div>
                            </button>
                        </div>
                    </li>
                );
            }
        }
        return display;
    }

    renderValueSuggestions() {
        var display = [];
        const uid = Utility.uuid4();
        for (var i = 0; i < this.props.suggestions.value.length; i++) {
            const value = this.props.suggestions.value[i];
            display.push(
                <li key={"value" + uid + i}>
                    <div
                        style={{ width: "auto", marginLeft: "-12px", marginRight: "-12px" }}
                        data-name={value}
                        onClick={event => {
                            this.props.context.applySuggestion(event.currentTarget.dataset.name, this.props.type);
                            document.removeEventListener('ev-input-nav-key', this.navKeyHandler);
                            this.selection = null;
                        }}
                    >
                        <button className="form-list-item item-button">
                            <div>{value}</div>
                        </button>
                    </div>
                </li>
            );
        }
        return display;
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        var display = [];
        if (this.props.type === "variable") {
            display = this.renderVariableSuggestions();
        }
        if (this.props.type === "intent") {
            display = this.renderIntentSuggestions();
        }
        if (this.props.type === "prompt") {
            display = this.renderPromptSuggestions();
        }
        if (this.props.type === "module") {
            display = this.renderModuleSuggestions();
        }
        if (this.props.type === "value") {
            display = this.renderValueSuggestions();
        }

        return <ul>{display}</ul>;
    }
}